export const environment = {
  production: true,
  versionCheckURL : 'https://www.parkingpass.com/version.json',
  api_key: '?qvP^Iar5;X3]dZ6n5w[34b2ao(TR6RM9{CG3Dd;]nUFqnd=RuG,@m_Lyp)&E~E',
  api_endpoint: 'https://api.parkingpass.com',

  sentry_dsn: 'https://2c52127eee914c34a9e3fd48ddc66fa3@o194743.ingest.sentry.io/5584156',
  release: '1.0.001'
};
